import cx from 'classnames'

import { Text, ScreenReaderText, SvgIcon } from '@cinch-labs/design-system'

import skeletonStyles from '../../skeleton.module.css'
import styles from './specs-list.module.css'
import { IconNames } from '@cinch-labs/design-system/dist/src/tokens/tokens.types'
import { RangeEstimationButtonAndModal } from '../../../range-estimation'

export interface SpecsListItem {
  label?: string
  value: string | number
  icon?: keyof typeof IconNames
  rangeType?: string
}

interface Props {
  items: SpecsListItem[]
  isPending: boolean
  listStyleClassName?: string
  listItemClassName?: string
  isUpperCaseText?: boolean
  isBrandNewVehicle?: boolean
}

const SpecsList = ({
  items = [],
  isPending = false,
  listStyleClassName = '',
  listItemClassName = '',
  isUpperCaseText = true,
  isBrandNewVehicle = false,
}: Props) => (
  <ul
    className={cx(styles['list'], listStyleClassName, {
      [styles['upperCase']]: isUpperCaseText,
    })}
  >
    {isBrandNewVehicle && (
      <Text
        element="li"
        fontSizeFixed="3xs"
        className={cx(styles['item'], listItemClassName, {
          [styles['brandNewVehicleItem']]: !isPending,
          [skeletonStyles['base']]: isPending,
          [skeletonStyles['active']]: isPending,
        })}
      >
        New Car
      </Text>
    )}
    {items.map(({ label, value, icon, rangeType }) => (
      <Text
        key={label}
        element="li"
        fontSizeFixed="3xs"
        className={cx(styles['item'], listItemClassName, {
          [skeletonStyles['base']]: isPending,
          [skeletonStyles['active']]: isPending,
        })}
      >
        <ScreenReaderText>{label}, </ScreenReaderText>
        {rangeType ? (
          <RangeEstimationButtonAndModal rangeType={rangeType}>
            {value}
            {icon && (
              <SvgIcon
                name={icon}
                size={18}
                role="img"
                style={{ marginLeft: '4px' }}
              />
            )}
          </RangeEstimationButtonAndModal>
        ) : (
          <>
            {value}
            {icon && <SvgIcon name={icon} size={18} role="img" />}
          </>
        )}
      </Text>
    ))}
  </ul>
)

export default SpecsList
